import { ReactNode } from 'react';
import { Flex, ResponsiveModal, ResponsiveModalContent } from '@bridebook/aura';

interface IProps {
  show: boolean;
  children: ReactNode;
  onClose?: () => void;
}

interface IPropsChildren {
  children: ReactNode;
}

const Body = ({ children }: IPropsChildren) => (
  <Flex className="mt-[env(safe-area-inset-top)] mb-[env(safe-area-inset-bottom)] h-full flex-col items-center overflow-auto px-8 py-4 text-center">
    {children}
  </Flex>
);

const InnerContent = ({ children }: IPropsChildren) => (
  <Flex className="flex-1 flex-col items-center gap-8 overflow-auto">{children}</Flex>
);

const Title = ({ children }: IPropsChildren) => (
  <div className="font-display text-[24px] font-extrabold break-words antialiased md:text-[28px]">
    {children}
  </div>
);

const Icon = ({ children }: IPropsChildren) => (
  <Flex className="items-center justify-center pt-12 pb-4">{children}</Flex>
);

const Buttons = ({ children }: IPropsChildren) => (
  <Flex className="w-full flex-col pt-4 pb-2">{children}</Flex>
);

const Description = ({ children }: IPropsChildren) => (
  <p className="pb-2 text-base text-space-60 max-[568px]:text-sm">{children}</p>
);

const PrePromptModal = ({ show, children, onClose }: IProps) => {
  const handleOpenChange = (open: boolean) => {
    if (!open) onClose?.();
  };

  return (
    <ResponsiveModal isOpen={show} onOpenChange={handleOpenChange} className="overflow-hidden">
      <ResponsiveModalContent className="h-[100vh] p-0">
        <Flex className="fixed bottom-0 h-full w-full flex-col overflow-hidden bg-white">
          <Flex className="h-full flex-col items-center">{children}</Flex>
        </Flex>
      </ResponsiveModalContent>
    </ResponsiveModal>
  );
};

PrePromptModal.Body = Body;
PrePromptModal.InnerContent = InnerContent;
PrePromptModal.Title = Title;
PrePromptModal.Description = Description;
PrePromptModal.Buttons = Buttons;
PrePromptModal.Icon = Icon;

export default PrePromptModal;
